<template>
  <div id="couponList" class="coupon-list">
    <second-menu-link-content>
      <template v-slot:header>
        <span>优惠劵</span>
      </template>
      <template v-slot:content>
        <div class="btn-container">
          <el-button class="btn-blue" @click="toAddCoupon">新增优惠券</el-button>
        </div>
        <div class="filter-coupon" ref="filterCouponContainerEle">
          <el-form class="filter-coupon-form" ref="filterCouponFormEle" :model="optionsForm">
            <div class="inner-container">
              <el-form-item label="优惠券名称：" prop="name">
                <el-input
                  class="white"
                  placeholder="请输入优惠券名称"
                  @keyup.enter.native="toFilterCoupon"
                  v-model="optionsForm.name"
                ></el-input>
              </el-form-item>
              <el-form-item label="优惠券状态：" prop="status">
                <el-select
                  class="white"
                  clearable
                  placeholder="请选择优惠券状态"
                  v-model="optionsForm.status"
                >
                  <el-option
                    v-for="(item, index) in couponStatusList"
                    :key="index"
                    :label="item.value"
                    :value="item.status"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="发放方式：" prop="assignMethod">
                <el-select
                  class="white"
                  clearable
                  placeholder="请选择发放方式"
                  v-model="optionsForm.assignMethod"
                >
                  <el-option
                    v-for="(item, index) in assignMethodList"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="inner-container">
              <el-form-item label="有效日期：" prop="effectiveTime">
                <el-date-picker
                  v-model="optionsForm.effectiveTime"
                  type="daterange"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                ></el-date-picker>
              </el-form-item>
            </div>
            <div class="operations">
              <el-button class="btn-blue" @click="toFilterCoupon">筛选</el-button>
              <span class="reset-btn" @click="clearFilterCondition">清空筛选条件</span>
            </div>
          </el-form>
        </div>
        <div class="coupon-list-container">
          <div class="table-img coupon-list-table" ref="couponList">
            <el-table class="table-container" :data="couponList">
              <el-table-column label="优惠券名称" prop="name" min-width="180"></el-table-column>
              <el-table-column label="有效日期" min-width="120">
                <template slot-scope="props">
                  <div
                    class="range-time"
                    v-show="props.row.timeType === effectiveTimeTypes.rangeTime"
                  >{{props.row.beginTime}}至{{props.row.endTime}}</div>
                  <div
                    class="limit-time"
                    v-show="props.row.timeType === effectiveTimeTypes.limitTime"
                  >领取后{{props.row.effectiveTime}}天内有效</div>
                </template>
              </el-table-column>
              <el-table-column label="面值(元)" prop="faceValue" min-width="80"></el-table-column>
              <el-table-column label="使用条件" min-width="100">
                <template slot-scope="props">
                  <span v-if="props.row.baseMoney">满{{props.row.baseMoney}}元可用</span>
                  <span v-else>无限制</span>
                </template>
              </el-table-column>
              <el-table-column label="商品范围" prop="useRangeDesc" min-width="100"></el-table-column>
              <el-table-column label="总数量" prop="totalCount" min-width="80"></el-table-column>
              <el-table-column label="已发放" prop="assignedCount" min-width="80"></el-table-column>
              <el-table-column label="限领" prop="perPersonLimit" min-width="80"></el-table-column>
              <el-table-column label="状态" prop="statusDesc" min-width="70"></el-table-column>
              <el-table-column label="发放方式" prop="assignMethodDesc" min-width="100"></el-table-column>
              <el-table-column label="操作" min-width="120">
                <template slot-scope="props">
                  <!-- 进行中 -->
                  <div
                    class="processing-coupon"
                    v-if="props.row.status === couponStatusMap.processing"
                  >
                    <span class="column-btn detail-btn" @click="toDetail(props.row.id)">详情</span>
                    <span
                      class="column-btn update-btn"
                      @click="toUpdate(props.row.id, props.row.status)"
                    >禁用</span>
                    <span
                      class="column-btn assign-btn"
                      v-if="props.row.assignMethod === assignMethodMap.passive"
                      @click="toAssign(props.row.id)"
                    >发放</span>
                  </div>
                  <!-- 已停用 -->
                  <div
                    class="terminated-coupon"
                    v-if="props.row.status === couponStatusMap.terminated"
                  >
                    <span class="column-btn detail-btn" @click="toDetail(props.row.id)">详情</span>
                    <span
                      class="column-btn update-btn"
                      @click="toUpdate(props.row.id, props.row.status)"
                    >启用</span>
                  </div>
                  <!-- 已领完 -->
                  <div
                    class="over-limit-coupon"
                    v-if="props.row.status === couponStatusMap.overLimit"
                  >
                    <span class="column-btn detail-btn" @click="toDetail(props.row.id)">详情</span>
                  </div>
                  <!-- 已结束 -->
                  <div class="finished-coupon" v-if="props.row.status === couponStatusMap.finished">
                    <span class="column-btn detail-btn" @click="toDetail(props.row.id)">详情</span>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="pagination-tpl-container">
            <pagination-tpl
              :total="totalNum"
              :currentPage="currentPage"
              @queryChange="onQueryChange"
            ></pagination-tpl>
          </div>
        </div>
      </template>
    </second-menu-link-content>
  </div>
</template>

<script >
import SecondMenuLinkContent from "components/layout/SecondMenuLinkContent";
import { formatTimeToDate } from "common/js/util.js";
import PaginationTpl from "base/PaginationTpl";
import DBCoupon from "models/db/coupon";
const dbCoupon = new DBCoupon();
const effectiveTimeTypes = {
  rangeTime: 1,
  limitTime: 2,
};
const useRangeTypes = {
  // 全部商品
  1: "全部商品",
  // 指定分类
  2: "指定分类",
  // 指定商品
  3: "指定商品",
};
const couponStatusMap = {
  // 未启用
  unEnabled: 100,
  // 进行中
  processing: 200,
  // 已停用
  terminated: 300,
  // 已领完
  overLimit: 400,
  // 已结束
  finished: 500,
};
const couponDescList = {
  100: "未启用",
  200: "进行中",
  300: "已停用",
  400: "已领完",
  500: "已结束",
};
const assignMethodMap = {
  // 主动领取
  proactive: 1,
  // 定向发放
  passive: 2,
};
const assignDescList = {
  1: "主动领取",
  2: "定向发放",
};
export default {
  data() {
    return {
      // 优惠券总条数
      totalNum: 0,
      currentPage: 1,
      // 筛选优惠券条件
      optionsForm: {
        name: "",
        status: "",
        assignMethod: "",
        effectiveTime: null,
      },
      // 具体查询条件
      options: {
        currentPage: 1,
        title: "",
        status: "",
        issuanceMethod: "",
        beginTime: "",
        endTime: "",
      },
      couponStatusMap,
      couponStatusList: [
        {
          status: 100,
          value: "未启用",
        },
        {
          status: 200,
          value: "进行中",
        },
        {
          status: 300,
          value: "已停用",
        },
        {
          status: 400,
          value: "已领完",
        },
        {
          status: 500,
          value: "已结束",
        },
      ],
      assignMethodMap,
      assignMethodList: [
        {
          label: "主动领取",
          value: 1,
        },
        {
          label: "定向发放",
          value: 2,
        },
      ],
      effectiveTimeTypes,
      couponList: [],
    };
  },
  activated() {
    this._getCouponList();
  },
  methods: {
    toAddCoupon() {
      this.$router.push({
        path: "/admin/marketing/coupon/add-coupon",
      });
    },
    toDetail(couponId) {
      this.$router.push({
        path: "/admin/marketing/coupon/coupon-detail",
        query: {
          id: couponId,
        },
      });
    },
    toUpdate(couponId, couponStatus) {
      let data = {
        id: couponId,
      };
      if (couponStatus === 200) {
        data.flag = 2;
      } else if (couponStatus === 300) {
        data.flag = 1;
      }
      this._updateCouponStatus(data);
    },
    toAssign(couponId) {
      this.$router.push({
        path: "/admin/marketing/coupon/assign-coupon",
        query: {
          couponId: couponId,
        },
      });
    },
    toFilterCoupon() {
      this.currentPage = 1;
      let beginTime = "";
      let endTime = "";
      if (this.optionsForm.effectiveTime) {
        beginTime = this.optionsForm.effectiveTime[0];
        endTime = this.optionsForm.effectiveTime[1];
      }
      this.options = Object.assign(this.options, {
        currentPage: this.currentPage,
        title: this.optionsForm.name,
        status: this.optionsForm.status,
        issuanceMethod: this.optionsForm.assignMethod,
        beginTime: beginTime,
        endTime: endTime,
      });
      this._getCouponList();
    },
    // 清空筛选条件
    clearFilterCondition() {
      this.$refs.filterCouponFormEle.resetFields();
      this.toFilterCoupon();
    },
    onQueryChange(query) {
      this.options.currentPage = query.currentPage;
      this._getCouponList();
    },
    _getCouponList() {
      console.log("当前查询条件", this.options);
      dbCoupon.getCouponList(this.options).then((res) => {
        if (res.success) {
          console.log("获取优惠券列表成功", res);
          let { currentPage, totalNum, items } = res.result;
          this.currentPage = currentPage;
          this.totalNum = totalNum;
          this.couponList = [];
          items.map((coupon) => {
            this.couponList.push({
              id: coupon.id,
              name: coupon.title,
              timeType: coupon.timeType,
              beginTime: formatTimeToDate(coupon.beginTime),
              endTime: formatTimeToDate(coupon.endTime),
              effectiveTime: coupon.effectiveTime,
              faceValue: coupon.faceValue,
              baseMoney: coupon.baseMoney,
              instruction: coupon.instruction,
              // 1 -- 无门槛 2 -- 满 N 元可用
              useCondition: coupon.useCondition,
              // 商品范围
              useRangeDesc: useRangeTypes[coupon.goodsLimit],
              // 总数量
              totalCount:
                coupon.issuanceMethod === assignMethodMap.passive
                  ? ""
                  : coupon.num,
              // 已发放数量
              assignedCount: coupon.issuanceNum,
              perPersonLimit:
                coupon.issuanceMethod === assignMethodMap.passive
                  ? ""
                  : coupon.receivedLimit,
              status: coupon.status,
              statusDesc: couponDescList[coupon.status],
              assignMethod: coupon.issuanceMethod,
              assignMethodDesc: assignDescList[coupon.issuanceMethod],
            });
          });
        } else {
          this.$message({
            message: res.message,
            center: true,
            type: "error",
            duration: 1000,
          });
        }
      });
    },
    // 更新优惠券状态
    _updateCouponStatus(data) {
      dbCoupon.updateCouponStatus(data).then((res) => {
        if (res.success) {
          this.$message({
            message: data.flag === 1 ? "启用成功" : "停用成功",
            center: true,
            type: "success",
            duration: 1000,
          });
          this._getCouponList();
        } else {
          this.$message({
            message: res.message,
            center: true,
            type: "error",
            duration: 1000,
          });
        }
      });
    },
  },
  created() {
    if (Number(this.$route.query.status)) {
      this.optionsForm.status = Number(this.$route.query.status);
      this.options.status = Number(this.$route.query.status);
    }
    this._getCouponList();
  },
  mounted() {
    this.$refs.couponList.style.width = `${this.$refs.filterCouponContainerEle.clientWidth}px`;
  },
  components: {
    SecondMenuLinkContent,
    PaginationTpl,
  },
};
</script>

<style lang="scss" scoped>
.coupon-list {
  width: 100%;
  height: 100%;
  font-size: 14px;
  color: rgba(96, 98, 102, 1);
  .filter-coupon {
    margin-top: 16px;
    padding: 22px 20px 26px 20px;
    background: rgba(245, 247, 250, 1);
    border-radius: 4px;
    .filter-coupon-form {
      .inner-container {
        display: flex;
      }
      .operations {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding-left: 100px;
        .btn-blue {
          margin-right: 16px;
        }
        .reset-btn {
          cursor: pointer;
          font-size: 12px;
          font-family: "PingFangSC-Regular";
          font-weight: 400;
          color: rgba(61, 116, 242, 1);
          margin-left: 20px;
        }
      }
    }
  }
  .coupon-list-container {
    margin-top: 24px;
    .coupon-list-table {
      .range-time {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }
      .column-btn {
        margin-right: 10px;
        font-size: 12px;
        white-space: nowrap;
        color: rgba(61, 116, 242, 1);
        cursor: pointer;
      }
    }
    .pagination-tpl-container {
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }
  }
}
</style>

<style lang="scss">
#couponList {
  .el-form {
    .el-form-item {
      display: flex;
      &:nth-child(1),
      &:nth-child(2) {
        margin-right: 60px;
      }
      .el-form-item__label {
        width: 100px;
        text-align: right;
      }
      .el-form-item__content {
        width: 160px;
      }
    }
  }
  .table-img {
    box-sizing: border-box;
    .el-table {
      width: 100%;
      overflow: auto;
      box-sizing: border-box;
      .el-table__body-wrapper {
        .el-table__body {
          padding-bottom: 0px;
          tbody {
            tr {
              td {
                box-sizing: border-box;
                padding: 0;
                margin: 0;
                .cell {
                  height: 48px;
                  padding-right: 0;
                }
              }
            }
          }
        }
      }
      .el-table__fixed-right {
        .el-table__fixed-header-wrapper {
          .el-table__header {
            thead {
              tr {
                th:nth-child(11) {
                  box-sizing: border-box;
                  padding: 0;
                  margin: 0;
                  .cell {
                    height: 32px;
                  }
                  background: rgba(245, 247, 250, 1);
                }
              }
            }
          }
        }
        .el-table__fixed-body-wrapper {
          .el-table__body {
            padding-bottom: 10px;
            tbody {
              tr {
                td:nth-child(11) {
                  padding: 0;
                  margin: 0;
                  .cell {
                    height: 48px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                  }
                }
              }
            }
          }
        }
      }
      .el-table__fixed-right {
        box-shadow: -3px 0px 8px 0px rgba(0, 0, 0, 0.11);
        th {
          .cell {
            text-align: center;
          }
        }
        td {
          padding: 0;
          .cell {
            height: 32px;
            line-height: 32px;
            padding: 0 16px;
            display: flex;
            justify-content: space-between;
            .up-down-update {
              flex: 2;
              display: flex;
              justify-content: space-around;
              .update {
                margin-right: 5px;
              }
            }
            > .el-button {
              flex: 1;
            }
          }
          background: rgba(245, 247, 250, 1);
          .el-button--text {
            color: #3d74f2;
            font-size: 12px;
          }
        }
      }
    }
  }
}
</style>
